// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"190":"25d1c1d9","512":"0f38fdfb"}[chunkId] + ".chunk.js");